<template v-if="dbName && colName" class="text-center">
    <div class="row gx-1 align-items-center">
        <div class="col-auto">
           特殊能力
        </div>
        <div class="col-4 col-lg-2">
            <d-editable-select v-model="dataId1" :options="options1" max-height="150" allow-clear="true"></d-editable-select>
        </div>
    </div>
    <div class="row gx-1 align-items-center">
        <div class="col-auto"> * </div>
        <div class="col-3 col-sm-2">
            <input type="search" v-model="gte1" @keyup.enter="queryTraits1(dbName, ['weapons','armors','states','classes'], 23, dataId1, {'$lte':lte1/100,'$gte':gte1/100})" class="form-control">
        </div>
        <div class="col-auto"> ~ </div>
        <div class="col-3 col-sm-2">
            <input type="search" v-model="lte1" @keyup.enter="queryTraits1(dbName, ['weapons','armors','states','classes'], 23, dataId1, {'$lte':lte1/100,'$gte':gte1/100})" class="form-control">
        </div>
        <div class="col-auto"> % </div>
        <div class="col-auto">
            <button type="submit" @click="queryTraits1(dbName, ['weapons','armors','states','classes'], 23, dataId1, {'$lte':lte1/100,'$gte':gte1/100})" class="btn btn-primary">搜索</button>
        </div>
        <div class="col-auto align-self-end">
            <CButton color="primary" @click="visible1 = !visible1" >折叠</CButton>
        </div>
    </div>
    <CCollapse :visible="visible1">
        <json-viewer
            :value="json1"
            :expand-depth=4
            :show-double-quotes="false"
            :show-array-index="false">
        </json-viewer>
    </CCollapse>
    <div class="row mt-4 mp-4"></div>
<!-- ************* -->
    <div class="row gx-1 align-items-center">
        <div class="col-auto">
            附加能力
        </div>
        <div class="col-4 col-lg-2">
            <d-editable-select v-model="dataId2" :options="options2" max-height="150" allow-clear="true"></d-editable-select>
        </div>
    </div>
    <div class="row gx-1 align-items-center">
        <div class="col-auto"> + </div>
        <div class="col-3 col-sm-2">
            <input type="search" v-model="gte2" @keyup.enter="queryTraits2(dbName, ['weapons','armors','states','classes'], 22, dataId2, {'$lte':lte2/100,'$gte':gte2/100})" class="form-control">
        </div>
        <div class="col-auto"> ~ </div>
        <div class="col-3 col-sm-2">
            <input type="search" v-model="lte2" @keyup.enter="queryTraits2(dbName, ['weapons','armors','states','classes'], 22, dataId2, {'$lte':lte2/100,'$gte':gte2/100})" class="form-control">
        </div>
        <div class="col-auto"> % </div>
        <div class="col-auto">
            <button type="submit" @click="queryTraits2(dbName, ['weapons','armors','states','classes'], 22, dataId2, {'$lte':lte2/100,'$gte':gte2/100})" class="btn btn-primary">搜索</button>
        </div>
        <div class="col-auto align-self-end">
            <CButton color="primary" @click="visible2 = !visible2" >折叠</CButton>
        </div>
    </div>
    <CCollapse :visible="visible2">
        <json-viewer
            :value="json2"
            :expand-depth=4
            :show-double-quotes="false"
            :show-array-index="false">
        </json-viewer>
    </CCollapse>
</template>
  
<script>
import axios from "@/utils/http"
import { CCollapse } from '@coreui/vue'
// import { CCard } from '@coreui/vue'
// import { CCardBody } from '@coreui/vue'
import { CButton } from '@coreui/vue'
import JsonViewer from 'vue-json-viewer'

export default {
    name: 'CommonQuery',
    components: {
        CCollapse, CButton,
        JsonViewer
    },
    data() {
        return {
            visible1: false,
            visible2: false,
            json1:null,
            json2:null,
            dataId1:"",
            dataId2:"",
            options2:[
                {'label': '物理命中', 'value': 0},
                {'label': '物理闪避', 'value': 1},
                {'label': '暴击率', 'value': 2},
                {'label': '暴击闪避', 'value': 3},
                {'label': '魔法闪避', 'value': 4},
                {'label': '魔法反射', 'value': 5},
                {'label': '物理反击', 'value': 6},
                {'label': '体力再生', 'value': 7},
                {'label': '魔力再生', 'value': 8},
                {'label': '特技再生', 'value': 9},
                // {'label': '攻击次数', 'value': 'ex'}, //特殊处理的
            ],
            options1:[
                {'label': '攻击吸引率', 'value': 0},
                {'label': '防御效果率', 'value': 1},
                {'label': '恢复效果率', 'value': 2},
                {'label': '药理知识', 'value': 3},
                {'label': '魔力消耗率', 'value': 4},
                {'label': '特技补充率', 'value': 5},
                {'label': '物理伤害加成', 'value': 6},
                {'label': '魔法伤害加成', 'value': 7},
                {'label': '地形伤害加成', 'value': 8},
                {'label': '经验获取加成', 'value': 9},
                {'label': '行动次数', 'value': 'ex'}, //特殊处理
            ],
            gte2:-100,
            lte2:100,
            gte1:0,
            lte1:1000,
        }
    },
    props: ['dbName'],
    methods: {
        queryTraits1(dbName, colList, code, dataId, value){
            this.visible1 = true
            if(dataId == 'ex'){
                axios.post('/' + dbName + '/others', { type:'traits', colList: colList, code:61, value:value })
                    .then(response => { this.json1 = response.data })
            }else{
                axios.post('/' + dbName + '/others', { type:'traits', colList: colList, code:code, dataId:dataId, value:value })
                    .then(response => { this.json1 = response.data })
            }
        },
        queryTraits2(dbName, colList, code, dataId, value){
            this.visible2 = true
            if(dataId == 'ex'){
                axios.post('/' + dbName + '/others', { type:'traits', colList: colList, code:34, value:value })
                .then(response => { this.json2 = response.data })
            }else{
                axios.post('/' + dbName + '/others', { type:'traits', colList: colList, code:code, dataId:dataId, value:value })
                    .then(response => { this.json2 = response.data })
            }
        },
    },
    created() {
    }
}
</script>
